// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__rNuYi","label":"SetPasswdForm_label__2759A"};